import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { getTelemetry } from '@cian/telemetry/browser';

import { IApplicationContext, IApplicationContextCustom } from '../../../shared/types/applicationContext';
import { createMakeRequest } from '../../client';
import { GET_USER_GA_DATA_LAYER_DEFAULT } from '../../../app/helpers/request_helper';
import { createMicrofrontendsAPI } from '../microfrontends';

export function createContext(): IApplicationContext {
  const config = getConfig();
  const httpApi = getHttpApi();
  const logger = getLogger();

  return {
    makeRequest: createMakeRequest(
      httpApi,
      window.__content_api_schema__,
      window.__content_api_host__,
      window.__content_api_path__,
      logger,
    ),
    getUserGaDataLayer: window.__get_user_ga_data_layer_timeout__ || GET_USER_GA_DATA_LAYER_DEFAULT,
    config,
    logger,
    httpApi,
    telemetry: getTelemetry(),
    custom: config.getStrict<IApplicationContextCustom>('applicationContext.custom'),
    microfrontendsAPI: createMicrofrontendsAPI(),
  };
}
